module.exports = __webpack_public_path__ + "img/jingke.4d28d904.png";